import axios from "axios";
import { toast } from "react-toastify";
import {
  NETWORK_ERROR,
  NOT_FOUND_ERROR,
  PERMISSION_ERROR,
  SERVER_ERROR,
  SERVER_NOT_RESPONDING_ISSUE,
} from "../utils/constant";


const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: "application/json",
  },
  withCredentials: false,
});

async function isOnline() {
  try {
      await fetch("https://www.google.com/favicon.ico", {
      method: "HEAD",
      mode: "no-cors",
    });
    return true; // Internet is accessible
  } catch (error) {
    return false; // No internet access
  }
}

// Interceptor for handling success and error responses
async function errorResponseHandler(error) {
 if (!error.response) {
    // Network error
    toast.error(SERVER_NOT_RESPONDING_ISSUE);
  } else {
    const { status, data } = error.response;
    // Handle specific HTTP status codes
    console.log('erorr response,', data.message[0])
    if (status === 403) {
      toast.error(PERMISSION_ERROR);
    } else if (status === 404) {
      toast.error(NOT_FOUND_ERROR);
    } else if (status >= 500) {
      toast.error(SERVER_ERROR);
    } 
    else if (
      data.message === 'No plan found against user.' ||
      data.message === 'No domain found against user' ||
      data.message === 'Invalid user id'
    ) {
        // your logic here
    } 
    else {
      toast.error(Array.isArray(data.message) ? data.message[0] : data?.message || "An unexpected error occurred.");
    }
  }

  return Promise.reject(error);
}

// Interceptor for handling successful responses
function successResponseHandler(response) {
  // Optionally display a success message
  if (response?.data?.message) {
    toast.success(response.data.message);
  }
  return response;
}

axiosInstance.interceptors.request.use(


  async (config) => {
    const isConnectedToInternet = await isOnline();
    if (!isConnectedToInternet) {
      toast.error(NETWORK_ERROR);
    }
    const token = sessionStorage.getItem("authToken"); // Retrieve token from sessionStorage or any other storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const currentLang = sessionStorage.getItem("preferredLanguage") || "en";
    if(currentLang) {
      config.headers['Accept-Language'] = currentLang
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Apply interceptors to the axios instance
axiosInstance.interceptors.response.use(
  successResponseHandler,
  errorResponseHandler
);

export default axiosInstance;
